import React from 'react';
import PropTypes from 'prop-types';
import ReactTimeout from 'react-timeout';
import { connect } from 'react-redux';
import { setLanguage } from 'redux-i18n';

import { setBookingData } from 'bookingform';
import {
  setShowDistributions,
  setRateType as setRateTypeInBookingForm,
  setAgentCode as setAgentCodeInBookingForm,
  setAgentSell as setAgentSellInBookingForm,
  setAgentUseCoins as setAgentUseCoinsInBookingForm,
} from 'bookingform/dist/export/actions';
import {
  BOOKING_STEP,
  getCartShare,
  setHotel,
  setLastRequestedInfo,
  setCurrencies,
  setFilterCurrency,
  findHotelDestination,
  setStep,
  setAgentCode,
  setRateType,
  setAgentSell,
  setAgentUseCoins,
} from '../../actions/Booking';
import { setCartUpdating, updateCartContent } from '../../actions/Cart';
import { isValidAge } from '../../utils/Room';

import '../../static/less/layout/loading_screen.less';
import { store } from '../../Store';
import withNavigate from '../../withNavigate'; // Importa el HOC

// Había un error de que cuando compartías un link y abrías ese link, hacías el pago
// te llevaba a la página de gracias pero dejaba abierto el input de distributions
// debido a que la variable showDistributions del storage estaba igual a true
// cuando en realidad tendría que estar en false, entonces usamos setShowDistributions
// para setear su valor en false

const SESSION_TIMEOUT = 2500;

const cartRoomToDistribution = (hotel, cartRoom) => {
  const { use } = cartRoom;
  const children = use.ages.filter((age) => isValidAge(hotel, 'children', age)).length;
  return { adl: use.adults, chd: children, enf: use.childs - children };
};

class CartShare extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      cartShareError: false,
      sessionTimeout: false,
    };
    // Timeout
    this.timeoutId = null;
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillMount() {
    const { token, lang } = this.props.params;
    if (!token) {
      this.props.navigate('/');
      return;
    }
    this.props.dispatch(setStep(BOOKING_STEP.NO_AVAIL_STEP));

    // When the language in the URL does not match the current one, change the language
    if (this.props.lang !== lang) {
      this.props.dispatch(setLanguage(lang));
    }

    // The "cart-share" request needs to have a session, so we'll make sure we have it first
    this.loadCartWithSession();
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(nextProps, nextState) {
    if (!this.props.sessionId && nextProps.sessionId) {
      // We can now load the cart and cancel the timeout
      this.props.clearTimeout(this.timeoutId);
      this.loadCartDetails();
    } else if (nextState.sessionTimeout) {
      this.setState({ cartShareError: true, isLoading: false });
    }
  }

  loadCartWithSession() {
    if (this.props.sessionId) {
      this.loadCartDetails();
    } else {
      // Since we don't have a session, we'll wait for it up to "SESSION_TIMEOUT" ms
      this.timeoutId = this.props.setTimeout(() => {
        // The timer has expired before the session has been received, so we will show an error
        if (!this.props.sessionId) {
          this.setState({ sessionTimeout: true });
        }
      }, SESSION_TIMEOUT);
    }
  }

  loadCartDetails() {
    this.setState({ isLoading: true });
    //acá
    const { token, lang } = this.props.params;
    this.props.dispatch(getCartShare(token, lang)).then((response) => {
      if (response && response.error_code === '00') {
        try {
          // First we make sure that the information is valid, so we load it on the different elements of the store
          this.loadCartShareDetails(response);
          this.setState({ cartShareError: false, isLoading: false });
          // Since we could load all data, we can now set the cart on the state and proceed to Confirmation page
          this.props.dispatch(updateCartContent(response.cart));
          this.props.dispatch(setCartUpdating(false));
          this.props.navigate('/confirmation/');
        } catch (e) {
          this.setState({ cartShareError: true, isLoading: false });
        }
      } else {
        this.setState({ cartShareError: true, isLoading: false });
      }
    });
  }

  loadCartShareDetails({
    availability, cart, agent_code, rate_type, agent_sell, agent_use_coins,
  }) {
    // Obtaining information about the HOTEL
    const cartHotel = cart.hotels[0];
    const availHotel = { ...availability.availables[0] };
    const fullHotel = findHotelDestination(this.props.countries, availHotel.code);
    availHotel.pk = fullHotel.pk; // The PK is necessary for launching new availabilities

    // Obtaining information about the ROOMs, both in "roomChoice" and "distri" formats
    const cartRooms = cartHotel.rooms;
    const distris = cartRooms.map((cartRoom) => cartRoomToDistribution(availHotel, cartRoom));

    // Now we generate a map for the availability results, as each requested room has an entry on that map
    /*const hotelRooms = {};
    availHotel.rooms.forEach((hotelRoom) => {
      const roomId = hotelRoom.request_id;
      const roomList = hotelRooms[roomId] || [];
      roomList.push(hotelRoom);
      hotelRooms[roomId] = roomList;
    });*/
    //const hotelRooms = cartRooms;

    // Once we have all the information, we can set it on the store
    const lastRequest = availability.requested_info;
    this.props.dispatch(setLastRequestedInfo(lastRequest));
    // Acá debemos de traer el valor de agentCode, rateType, agentUseCoins y agentSell desde la bd
    // y setearlos acá para que cuando carge el link tenga esa información seteada

    const state2 = store.getState();
    state2.bookingFormState.agentCode = agent_code !== '-' ? agent_code : '';
    // Si el no viene agentCode, en bd guardamos un guión - y acá simplemente
    // si viene el guión, ponemos agentCode=''
    state2.bookingFormState.agentSell = agent_sell;
    state2.bookingFormState.rateType = rate_type;
    state2.booking.rateType = rate_type;
    state2.bookingFormState.agentUseCoins = agent_use_coins;
    state2.booking.agentUseCoins = agent_use_coins;
    state2.bookingFormState.showDistributions = false;

    this.props.dispatch(setBookingData({
      dest: fullHotel,
      checkIn: lastRequest.checkin,
      checkOut: lastRequest.checkout,
      promoCode: lastRequest.promocode || '',
      distributions: distris,
      chain: this.props.chain,
      origin: this.props.origin,
    }));

    this.props.dispatch(setAgentCode(agent_code !== '-' ? agent_code : ''));
    this.props.dispatch(setAgentCodeInBookingForm(agent_code !== '-' ? agent_code : ''));
    this.props.dispatch(setRateType(rate_type));
    this.props.dispatch(setRateTypeInBookingForm(rate_type));
    this.props.dispatch(setAgentSell(agent_sell));
    this.props.dispatch(setAgentSellInBookingForm(agent_sell));
    this.props.dispatch(setAgentUseCoins(agent_use_coins));
    this.props.dispatch(setAgentUseCoinsInBookingForm(agent_use_coins));
    this.props.dispatch(setShowDistributions(false));

    // The hotel needs to be set after the destination is
    this.props.dispatch(setHotel(availHotel));

    // The initial currency will be the same as in the hotel
    const filterCurrency = availHotel.currencies.find((currency) => currency.code === availHotel.default_currency);
    this.props.dispatch(setCurrencies(availHotel.currencies));
    this.props.dispatch(setFilterCurrency(filterCurrency));
  }

  render() {
    // We display a message while loading or when an error occurs. Otherwise, just wait for the redirection
    return (
      <div className="LoadingScreen LoadingScreen--mute pt-5">
        {this.state.isLoading && this.context.t('Loading details from the Share link...')}
        {this.state.cartShareError && this.context.t('Sorry, we could not load the details from the Share link')}
      </div>
    );
  }
}

CartShare.propTypes = {
  navigate: PropTypes.func.isRequired, // Prop para `navigate`
};

CartShare.contextTypes = {
  t: PropTypes.func.isRequired,
};

// Conectar el componente con Redux
const mapStateToProps = (state) => ({
  countries: state.bookingFormState.countries,
  sessionId: state.bookingFormState.sessionId,
  chain: state.bookingFormState.chain,
  origin: state.bookingFormState.origin,
});

// Envuelve el componente AlertMessage con el HOC withNavigate
const CartShareWithNavigate = withNavigate(
  ReactTimeout(connect(mapStateToProps)(CartShare)),
);

export default CartShareWithNavigate;
